import styled from '@emotion/styled';

export const ComponentWrapper = styled('div')``;

export const SearchWrapper = styled('div')``;

export const AddNewButton = styled('div')`
  display: flex;
  flex-direction: row-reverse;
  margin-right: 1.8vh;
  margin-top: -1.5rem;
`;
